import Box from '@mui/material/Box';
import { Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { FRONTAGE_FILTER_LABELS } from '../../constants/filterOptions';
import CheckboxFilter from 'components/commons/CheckboxFilter';
import React from 'react';

function FrontageFilter(props) {
    return (
        <Box
            sx={{
                mb: 2,
                width: '100%',
            }}
        >
            <Typography sx={{ mb: 2.5, display: 'block' }} variant="text4" gutterBottom>Frontage</Typography>
            <Grid container>
                {
                    Object.keys(FRONTAGE_FILTER_LABELS).map((value) => {
                        return (
                            <Grid item size={3} key={value}>
                                <CheckboxFilter
                                    value={FRONTAGE_FILTER_LABELS[value]}
                                    comparableType={props.comparableType}
                                    attrName={value}
                                />
                            </Grid>
                        );
                    })
                }

            </Grid>
            <Divider orientation="horizontal" sx={{mt: 3, mb: 3}}/>
        </Box>
    );
}

export default React.memo(FrontageFilter);